import React, { memo, HTMLProps } from "react";
import classnames from "classnames";
import { Element } from "../base";
import { twMerge } from "tailwind-merge";

interface IProps extends HTMLProps<HTMLAnchorElement> {
    className?: string;
    children: React.ReactNode;
    subtitle?: boolean;
    renderAs?: string;
    heading?: boolean;
}

function Title(props: IProps) {
    const {
        renderAs = "h3",
        children,
        className,
        subtitle,
        heading,
        ...rest
    } = props;
    return (
        <Element
            renderAs={renderAs}
            className={twMerge(
                classnames({
                    ["font-semibold block"]: !subtitle && !heading,
                    ["text-[var(--text-secondary)]"]: subtitle,
                    ["heading"]: heading,
                }),
                className
            )}
            {...rest}
        >
            {children}
        </Element>
    );
}

export default memo(Title);
